import React from "react";
import styled from "styled-components";
import { color, font } from "../tokens";
import { Inner, MonoLabel, Reveal } from "../primitives";
import { STATS } from "../data";
import AnimatedIcon from "../icons";

const Wrap = styled.div`
  padding-top: clamp(80px, 14vh, 160px);
  padding-bottom: clamp(120px, 20vh, 220px);
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: clamp(40px, 8vh, 90px);
`;

const StatsRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: clamp(32px, 6vw, 96px);
  flex-wrap: wrap;
`;

const Stat = styled.div`
  display: flex;
  align-items: baseline;
  gap: 14px;
`;

const Numeral = styled.span`
  font-family: ${font.display};
  font-size: clamp(72px, 9.5vw, 150px);
  font-weight: 400;
  line-height: 0.95;
  letter-spacing: 0.01em;
  color: ${color.ink};
`;

/** Giant numerals — eight years in three numbers. */
const StatsSection: React.FC = () => (
  <Wrap>
    <Inner>
      <Reveal>
        <Head>
          <AnimatedIcon name="activity" size={15} strokeWidth={2} />
          <MonoLabel>In numbers</MonoLabel>
        </Head>
        <StatsRow>
          {STATS.map((s) => (
            <Stat key={s.label}>
              <Numeral>{s.value}</Numeral>
              <MonoLabel>{s.label}</MonoLabel>
            </Stat>
          ))}
        </StatsRow>
      </Reveal>
    </Inner>
  </Wrap>
);

export default StatsSection;
